"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listCampaign = listCampaign;
exports.createCampaign = createCampaign;
exports.getAssignedCampaign = getAssignedCampaign;
exports.getAllCampaigns = getAllCampaigns;
exports.updateCampaign = updateCampaign;
exports.deleteCampaign = deleteCampaign;
exports.allSkillGroup = allSkillGroup;
exports.readAssigned = readAssigned;
exports.assignedCampaign = assignedCampaign;

var _request = _interopRequireDefault(require("@/utils/request"));

function listCampaign(query) {
  return (0, _request.default)({
    url: '/campaign/list',
    method: 'get',
    params: query
  });
}

function createCampaign(data) {
  return (0, _request.default)({
    url: '/campaign/create',
    method: 'post',
    data: data
  });
} //获取已分配的任务


function getAssignedCampaign() {
  return (0, _request.default)({
    url: '/campaign/getAssignedCampaign',
    method: 'get'
  });
} //获取所有任务


function getAllCampaigns() {
  return (0, _request.default)({
    url: '/campaign/getAllCampaigns',
    method: 'get'
  });
}

function updateCampaign(data) {
  return (0, _request.default)({
    url: '/campaign/update',
    method: 'post',
    data: data
  });
}

function deleteCampaign(data) {
  return (0, _request.default)({
    url: '/campaign/delete',
    method: 'post',
    data: data
  });
}

function allSkillGroup() {
  return (0, _request.default)({
    url: '/campaign/allSkillGroup',
    method: 'get'
  });
}
/* 获取已分配的用户或技能组信息*/


function readAssigned(data) {
  return (0, _request.default)({
    url: '/campaign/readAssigned',
    method: 'get',
    params: data
  });
} // 分配结果保存


function assignedCampaign(data) {
  return (0, _request.default)({
    url: '/campaign/assigned',
    method: 'post',
    data: data
  });
}